var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "supsisRightModal",
      class: ((_obj = { closed: _vm.closed }), (_obj[_vm.type] = true), _obj),
      style: { width: _vm.width, zIndex: _vm.zIndex },
      attrs: { id: "supsis-right-modal" },
    },
    [
      _c("div", { staticClass: "action-buttons" }, [
        _c(
          "div",
          {
            staticClass: "btnWindow closeAction",
            on: { click: _vm.closeModal },
          },
          [_c("div", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
        _vm._v(" "),
        _vm.sliderOptions()
          ? _c(
              "div",
              {
                staticClass: "btnWindow prevAction",
                class: {
                  disabled:
                    _vm.sliderOptions() && !_vm.sliderOptions().prevAvailable,
                },
                on: {
                  click: function () {
                    return _vm.sliderOptions() &&
                      _vm.sliderOptions().prevAvailable
                      ? _vm.sliderOptions().prev()
                      : _vm.$_.noop()
                  },
                },
              },
              [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v("arrow_back_ios"),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.sliderOptions()
          ? _c(
              "div",
              {
                staticClass: "btnWindow nextAction",
                class: {
                  disabled:
                    _vm.sliderOptions() && !_vm.sliderOptions().nextAvailable,
                },
                on: {
                  click: function () {
                    return _vm.sliderOptions() &&
                      _vm.sliderOptions().nextAvailable
                      ? _vm.sliderOptions().next()
                      : _vm.$_.noop()
                  },
                },
              },
              [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v("arrow_forward_ios"),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "head" }, [
        _vm.type === "editor-task"
          ? _c(
              "div",
              {
                staticClass: "title",
                attrs: { contenteditable: "true" },
                on: { input: _vm.updateTitle },
              },
              [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
            )
          : _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.description)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _vm.type === "create-task"
                ? _c(
                    "CreateTaskForm",
                    _vm._b(
                      {
                        attrs: { attachmentEditVisible: false },
                        on: { "update-form": _vm.updateForm },
                      },
                      "CreateTaskForm",
                      _vm.payload || {},
                      false
                    )
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "create-workflow"
                ? _c("WorkflowForm", { on: { "update-form": _vm.updateForm } })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "task-settings"
                ? _c("TaskSettings", { on: { "update-form": _vm.updateForm } })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "editor-task"
                ? _c("EditorTask", {
                    attrs: { details: _vm.payload },
                    on: {
                      "update-form": _vm.updateForm,
                      "close-modal": _vm.closeModal,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "edit-task"
                ? _c(
                    "CreateTaskForm",
                    _vm._b(
                      {
                        attrs: { attachmentFileVisible: false },
                        on: { "update-form": _vm.updateForm },
                      },
                      "CreateTaskForm",
                      _vm.payload,
                      false
                    )
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "visibility-workflow"
                ? _c("VisibilityWorkFlow", {
                    attrs: { details: _vm.payload },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "pipeline-edit"
                ? _c("PipelineStageForm", {
                    attrs: { details: _vm.payload },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "edit-workflow"
                ? _c("WorkflowForm", {
                    attrs: { details: _vm.payload },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "show-visitor"
                ? _c("VisitorDetail", {
                    attrs: { visitorId: _vm.payload.visitorId },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "calendar-settings"
                ? _c("CalendarSettings", { attrs: { payload: _vm.payload } })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.footer
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "classic-submit-button",
                on: {
                  click: function ($event) {
                    return _vm.saveChanges(_vm.type)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("wp.saveChanges")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "classic-submit-button",
                attrs: { type: "normal" },
                on: { click: _vm.closeModal },
              },
              [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }